import {omitBy} from 'lodash';

const YT_RELATED_VIDEOS = 'youtube_rel';
const YT_CONTROLS = 'youtube_controls';
const YT_FULL_SCREEN = 'youtube_fs';
const YT_MODEST_BRANDING = 'youtube_modestbranding';
const YT_MUTE = 'youtube_mute';
const YT_AUTOPLAY = 'youtube_autoplay';
const YT_START = 'youtube_start';

export type YouTubeParams = {
  youtube_rel?: string;
  youtube_controls?: string;
  youtube_fs?: string;
  youtube_modestbranding?: string;
  youtube_mute?: string;
  youtube_autoplay?: string;
  youtube_start?: string;
};

export const isYouTubeUrl = (url: string): boolean =>
  /www\.youtube\.com/.test(url) ||
  /youtube\.com/.test(url) ||
  /youtu\.be/.test(url) ||
  /youtube-nocookie\.com/.test(url);

export const isYouTubeNoCookieUrl = (url: string): boolean =>
  /youtube-nocookie\.com/.test(url);

// Make sure the url is youtube.com/watch?v={ID} not youtu.be/{ID}
// Because the embedly is no longer supporting short urls
export const cleanUrl = (oldUrl: string): string =>
  oldUrl.replace(/youtu\.be\/(.*)/g, 'youtube.com/watch?v=$1');

const omitNully = (obj: any) =>
  omitBy(obj, (value) => value == null || value === false);

export const getYouTubeParams = (url: string): YouTubeParams => {
  const relatedVideos = url.match(/rel=(\d+)/);
  const controls = url.match(/controls=(\d+)/);
  const fullScreen = url.match(/fs=(\d+)/);
  const modestBranding = url.match(/modestbranding=(\d+)/);
  const mute = url.match(/mute=(\d+)/);
  const autoplay = url.match(/autoplay=(\d+)/);
  const start = url.match(/start=(\d+)/) || url.match(/t=(\d+)/);

  return omitNully({
    [YT_RELATED_VIDEOS]: relatedVideos && relatedVideos[1],
    [YT_CONTROLS]: controls && controls[1],
    [YT_FULL_SCREEN]: fullScreen && fullScreen[1],
    [YT_MODEST_BRANDING]: modestBranding && modestBranding[1],
    [YT_MUTE]: mute && mute[1],
    [YT_AUTOPLAY]: autoplay && autoplay[1],
    [YT_START]: start && start[1],
  });
};

export const removeYouTubeParams = (url: string): string => {
  const urlParts = url.split('?');
  // embed links dont have /watch?v={id} param which we want to include
  // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
  if (urlParts[0].includes('embed') || urlParts[0].includes('.be'))
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return urlParts[0];
  // take first part of url and the /watch?v={id}
  // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
  return urlParts[0].concat('?', urlParts[1]);
};

export const buildYouTubeParams = (url: string): string => {
  const params = omitNully({
    autoplay: autoplay(url) ? 1 : false,
    ...getYouTubeParams(url),
  });

  const customParams = Object.keys(params);

  return customParams.length
    ? `?${customParams
        .reduce<
          string[]
        >((result, param) => result.concat(`${param.replace('youtube_', '')}=${params[param]}`), [])
        .join('&')}`
    : '';
};

export const autoplay = (url: string): boolean => /autoplay=(true|1)/.test(url);
